import { useCallback } from 'react';

import { client } from 'core/http';
import { Slot } from 'core/types/slot';

export default function useSlotDeletes() {
  return useCallback((axleId: number, slotId: number) => {
    return client()
      .delete<Slot>(`axles/${axleId}/slots/${slotId}`)
      .then(response => response.data);
  }, []);
}
